import { Component, useState} from "react";
import BaseModal from "../Base-modal";
import Input from "../../../blocks/Input";
import { useForm } from "../../../hooks/useForm";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ajax } from "../../../scripts/helper";
import { useSnackbar } from 'notistack'
import utils from "../../../scripts/utils";

const Content = ({closeModal, showModal}) => {

    const [inputFields, handleChange, setInputFields] = useForm({
        comment: {
            name: 'comment',
            value: '',
            type: 'textarea',
            placeholder: 'Write comment...'
        }
    })

    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const id = searchParams.get('id')

    const submitComment = async() => {
        if(!inputFields.comment.value){
            enqueueSnackbar('Commnet is required', {variant: 'error'})
            return
        }

        const detail = await ajax({
            method: 'GET',
            url: utils.urls.linkDetail(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!detail) return

        const data = {
            "comments": detail.data.comments + ' // Reject Reason:' + inputFields.comment.value
        }
        const res = await ajax({
            method: 'PUT',
            url: utils.urls.updateLink(id),
            hasToken: true,
            snackbar: enqueueSnackbar,
            data
        })
        if(!res) return

        const response = await ajax({
            method:"GET",
            url: utils.urls.transactionBlock(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!response) return


        navigate('/agent/payments')
    }

    
    return (
        <>
            <div style={{'direction': 'rtl', 'display': 'flex', 'justifyContent': 'center', 'marginBottom': '10px'}}>
                <h2 style={{'fontFamily': 'sans-serif'}}>Write Reason of Rejection</h2>
            </div>
            <div >
                <Input inputField={inputFields.comment} onChange={handleChange} />
            </div>
            <div className="btn-container">
                <button className="back" onClick={() => closeModal()}>Back</button>
                <button className="payment-btn-back" onClick={() => submitComment()}>Reject</button>
            </div>  
        </>
    )


}


class RejectModal extends Component {
    state = {
        open: false,
        inputs: {}
    }

    openModal = () => this.setState({open: true})
    closeModal = () => this.setState({open: false})

    render() {
        return (
            <BaseModal open={this.state.open} closeModal={this.closeModal}>
                <Content
                    {...this.props}
                    showModal={this.state.open}
                    closeModal={this.closeModal}
                />
            </BaseModal>
        )
    }
}

export default RejectModal